<template>
  <div class="margin-left">
    <p>{{ $t("contract.signature.date_label") }}</p>
    <p>
      {{ $t("contract.signature.company1_label") }}
      <span>{{ companyName }}</span>
    </p>
    <p>{{ $t("contract.signature.signature_label") }}</p>
    <br />
    <br />
    <p>{{ $t("contract.signature.date_label") }}</p>
    <p>
      {{ $t("contract.signature.company2_label") }}
      <span>{{ supplierName }}</span>
    </p>
    <p>{{ $t("contract.signature.signature_label") }}</p>
  </div>
</template>

<script>
export default {
  computed: {
    parties() {
      return this.$store.state.contract.parties;
    },
    companyName() {
      return this.parties.company.name !== ""
        ? this.parties.company.name
        : this.$t("contract.parties.placeholder.name");
    },
    supplierName() {
      return this.parties.supplier.name !== ""
        ? this.parties.supplier.name
        : this.$t("contract.parties.placeholder.name");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/apps/hemmelig/components/contract/Signature.vue